import create from 'zustand';

export interface ICustomPlanStore {
  customPrice: string | null;
  setCustomPrice(arg: string): void;
  enableRazorPayEntPlan: boolean;
  setEnableRazorPayEntPlan(arg: boolean): void;
  enableRazorPayEntBuyBtn: boolean;
  setEnableRazorPayEntBuyBtn(arg: boolean): void;
}

export const useCustomPlanStore = create<ICustomPlanStore>((set) => ({
  customPrice: null,
  setCustomPrice: (value: string) => set({ customPrice: value }),
  enableRazorPayEntPlan: false,
  setEnableRazorPayEntPlan: (value: boolean) => set({ enableRazorPayEntPlan: value }),
  enableRazorPayEntBuyBtn: false,
  setEnableRazorPayEntBuyBtn: (value: boolean) => set({ enableRazorPayEntBuyBtn: value }),
}));
